import { takeLatest } from "redux-saga/effects";
import { ActionType } from "./types/actionType";
import handlePlaceCustomRequest, {
  handleCreateSample,
  handleUpdateSample,
  handleDeleteSample,
  handleCustomRequest,
  handleImportSamples,
  handleExportSamples,
  handleRetrieveSample,
  handleSetPriceSamples,
  handleRetrieveManySamples,
  handleRetrieveManySamplesById,
  handleRetrieveManySamplesByLOINC,
} from "./workers";

export function* watcher() {
  yield takeLatest(ActionType.SET_PRICE, handleSetPriceSamples);
  yield takeLatest(ActionType.GET_SAMPLE, handleRetrieveSample);
  yield takeLatest(ActionType.CREATE_SAMPLE, handleCreateSample);
  yield takeLatest(ActionType.UPDATE_SAMPLE, handleUpdateSample);
  yield takeLatest(ActionType.DELETE_SAMPLE, handleDeleteSample);
  yield takeLatest(ActionType.GET_MANY_SAMPLES, handleRetrieveManySamples);
  yield takeLatest(ActionType.GET_MANY_SAMPLES_BY_ID, handleRetrieveManySamplesById);
  yield takeLatest(ActionType.CUSTOM_REQUEST, handleCustomRequest);
  yield takeLatest(ActionType.IMPORT_SAMPLES, handleImportSamples);
  yield takeLatest(ActionType.EXPORT_SAMPLES, handleExportSamples);
  yield takeLatest(ActionType.PLACE_CUSTOM_REQUEST, handlePlaceCustomRequest);
  yield takeLatest(ActionType.GET_MANY_SAMPLES_BY_LOINC, handleRetrieveManySamplesByLOINC);
}
